import React from "react";
import styled from "styled-components";
import { Collapse } from "reactstrap";
import TablaPoliza from "./TablaPoliza.js";
import TablaDep from "./TablaDep.js";
import TablaBen from "./TabBen.js";
import DocumentosPoliza from "./DocumentosPoliza.js";
import "bootstrap/dist/css/bootstrap.min.css";
import { useIdioma } from "./context/IdiomaContext";

const Container = styled.div`
  max-width: 1800px;
  margin: 40px auto;
  @media(max-width: 690px) {
    width: 300px;
  }
`;

const tabbedPolicyTypes = ["GM", "VD", "ACP"];

const SectionTitle = ({ icon, children, action }) => (
  <>
    <div className="policy-detail-title">
      <div className="d-flex align-items-center">
        <div
          className="rounded-circle bg-primary-subtle d-flex align-items-center justify-content-center me-2"
          style={{ width: 32, height: 32 }}
        >
          <span className="text-primary fw-bold">{icon}</span>
        </div>
        {children}
      </div>
      {action}
    </div>
    <hr className="policy-detail-divider" />
  </>
);

const Poliza = () => {
  const { t } = useIdioma();
  const tipoPoliza = sessionStorage.getItem("tipoPolizaCodigo") || window.tipoPolizaCodigo || "";
  const mostrarDocumentos = sessionStorage.getItem("mostrarDocumentos") === "1";
  const usarTabs = tabbedPolicyTypes.includes(tipoPoliza);
  const [activeTab, setActiveTab] = React.useState("poliza");
  const [docsOpen, setDocsOpen] = React.useState(true);

  const sections = [
    {
      id: "poliza",
      label: t("Póliza"),
      title: t("Información de póliza"),
      icon: "POL",
      content: <TablaPoliza />,
    },
    {
      id: "dependientes",
      label: t("Dependientes"),
      title: t("Dependientes de gastos médicos"),
      icon: "DEP",
      content: <TablaDep />,
    },
    {
      id: "beneficiarios",
      label: t("Beneficiarios"),
      title: t("Beneficiarios de vida"),
      icon: "BEN",
      content: <TablaBen />,
    },
  ];

  const tabs = mostrarDocumentos
    ? [
        ...sections,
        {
          id: "documentos",
          label: t("Documentos"),
          title: t("Biblioteca de documentos"),
          icon: "DOC",
          content: <DocumentosPoliza />,
        },
      ]
    : sections;

  if (usarTabs) {
    const currentTab = tabs.find((tab) => tab.id === activeTab) || tabs[0];

    return (
      <Container>
        <div className="policy-tabs-shell">
          <div className="policy-tabs-nav" role="tablist" aria-label={t("Información de póliza")}>
            {tabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                className={`policy-tabs-nav__button ${activeTab === tab.id ? "is-active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
                role="tab"
                aria-selected={activeTab === tab.id}
              >
                <span>{tab.icon}</span>
                {tab.label}
              </button>
            ))}
          </div>

          <div className="policy-tabs-panel" role="tabpanel">
            <SectionTitle icon={currentTab.icon}>{currentTab.title}</SectionTitle>
            {currentTab.content}
          </div>
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <div className="row">
        <div className="col-xs-12 col-lg-4 col-md-5" align="left">
          <SectionTitle icon="POL">{t("Información de póliza")}</SectionTitle>
          <TablaPoliza />
        </div>

        <div className="col-xs-12 col-lg-8 col-md-7">
          <div className="col-xs-12 col-md-12">
            <SectionTitle icon="DEP">{t("Dependientes de gastos médicos")}</SectionTitle>
            <TablaDep />
          </div>

          <br />
          <br />
          <br />

          <div className="col-xs-12 col-md-12">
            <SectionTitle icon="BEN">{t("Beneficiarios de vida")}</SectionTitle>
            <TablaBen />
          </div>

          <br />
          <br />

          {mostrarDocumentos && (
            <div className="col-xs-12 col-md-12">
              <div
                className="policy-detail-title policy-detail-title--button"
                role="button"
                tabIndex={0}
                onClick={() => setDocsOpen(!docsOpen)}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    setDocsOpen(!docsOpen);
                  }
                }}
              >
                <div className="d-flex align-items-center">
                  <div
                    className="rounded-circle bg-primary-subtle d-flex align-items-center justify-content-center me-2"
                    style={{ width: 32, height: 32 }}
                  >
                    <span className="text-primary fw-bold">DOC</span>
                  </div>
                  {t("Biblioteca de documentos")}
                </div>
                <div style={{ fontSize: 18, lineHeight: "18px" }}>
                  {docsOpen ? "v" : ">"}
                </div>
              </div>
              <hr className="policy-detail-divider" />
              <Collapse isOpen={docsOpen}>
                <DocumentosPoliza />
              </Collapse>
            </div>
          )}
        </div>
      </div>

      <br />
      <br />
    </Container>
  );
};

export default Poliza;
